import React, { PureComponent } from 'react'
import Chart from "react-apexcharts";

class PublicStateChart extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      showMenu: false,
      onPublicState: props.onPublicState || false,
    }
  }

  openMenu = () => {
    this.setState({
      showMenu: true
    })
  }

  filterNone = () => {
    if (!!this.state.onPublicState) {
      this.state.onPublicState(false)
    }
    this.setState({
      showMenu: false
    })
  }

  filterCancelled = () => {
    if (!!this.state.onPublicState) {
      this.state.onPublicState('CANCELLED')
    }
    this.setState({
      showMenu: false
    })
  }

  filterConfirmed = () => {
    if (!!this.state.onPublicState) {
      this.state.onPublicState('CONFIRMED')
    }
    this.setState({
      showMenu: false
    })
  }

  filterUncertain = () => {
    if (!!this.state.onPublicState) {
      this.state.onPublicState('UNCERTAIN')
    }
    this.setState({
      showMenu: false
    })
  }

  render() {
    const {events, filter} = this.props
    const {showMenu} = this.state
    const allEvents = (events && events.items) || []

    var cancelled = 0
    var confirmed = 0
    var uncertain = 0
    const iMax = allEvents.length
    for (var i=0;i<iMax;i++) {
      const event = allEvents[i]
      cancelled += (event.publicState === 'CANCELLED' ? 1 : 0)
      confirmed += (event.publicState === 'CONFIRMED' ? 1 : 0)
      uncertain += (event.publicState === 'UNCERTAIN' ? 1 : 0)
    }
    cancelled = parseInt((iMax === 0 ? 0 : (cancelled * 100 / iMax)).toFixed(0),0)
    confirmed = parseInt((iMax === 0 ? 0 : (confirmed * 100 / iMax)).toFixed(0),0)
    uncertain = 100 - (cancelled + confirmed)
    const series = [cancelled,uncertain,confirmed]

    const colorCancelled = ((!filter || filter === 'CANCELLED') ? '#CC0000' : '#999999')
    const colorConfirmed = ((!filter || filter === 'CONFIRMED') ? '#00AA00' : '#777777')
    const colorUncertain = ((!filter || filter === 'UNCERTAIN') ? '#F6ED16' : '#BBBBBB')

    return (
    <div id="PublicStateChart">
        {
          !!showMenu &&
          <div className="menu">
            <div className="option" onClick={this.filterNone}><div>ALLE EVENTS</div></div>
            <div className="option" onClick={this.filterCancelled}><div>ABGESAGT</div></div>
            <div className="option" onClick={this.filterUncertain}><div>UNGEWISS</div></div>
            <div className="option" onClick={this.filterConfirmed}><div>FINDET STATT</div></div>
          </div>
        }
        {
          iMax > 0 &&
          <Chart
            onClick={this.openMenu}
            options={{
              dataLabels: {enabled: false},
              legend: {show: false},
              colors: [colorCancelled, colorUncertain, colorConfirmed],
              labels: ['abgesagt', 'ungewiss', 'findet statt'],
              selection: {enabled: false},
              tooltip: {
                fillSeriesColor: false,
                y: {
                  formatter: (value, {seriesIndex}) => ''+value+'%'
                }
              }
            }}
            series={series}
            type="pie"
          />
        }
      </div>
    )
  }

}

export default PublicStateChart


// WEBPACK FOOTER //
// ./src/components/parts/PublicStateChart.js